import { render, staticRenderFns } from "./ProcurementResolveRFMToPOs.vue?vue&type=template&id=7da2ddff&"
import script from "./ProcurementResolveRFMToPOs.vue?vue&type=script&lang=js&"
export * from "./ProcurementResolveRFMToPOs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports